<template>
	<span>
		<div class="text-center">
			<loading :active.sync="isUploading" :background-color="colorOverlay" :color="colorLoading">
				<template slot="after">
					<div class="absolute mt-1 ml-1">{{ $t('Uploading') }}...</div>
				</template>
			</loading>
			<loading :active.sync="isUploadingAssets" :background-color="colorOverlay" :color="colorLoading">
				<template slot="after">
					<div class="absolute mt-1 ml-1">{{ $t('Uploading') }}...</div>
				</template>
			</loading>
		</div>
		<div>
			<div class="d-flex">
				<div class="form-group mb-3 col-sm-2 mt-4">
					<input
						type="text"
						class="form-control"
						:placeholder="$t('Name')"
						v-model="template.name"
						@keydown="textKeydown($event)"
					/>
				</div>
				<!-- Type -->
				<div class="form-group mb-3 mr-4 mt-4">
					<select
						name="type"
						class="form-control"
						v-model="template.type"
						required>
						<option
							v-for="typeOption in types"
							:key="typeOption.value"
							:value="typeOption.value">
							{{ typeOption.name }}
						</option>
					</select>
				</div>
				<!-- category -->
				<div class="form-group mb-3 mr-4 mt-4">
					<select
						name="size"
						class="form-control"
						v-model="template.category"
						required>
						<option
							v-for="categoryOption in categories"
							:key="categoryOption.id"
							:value="categoryOption.id">
							{{ categoryOption.name }}
						</option>
					</select>
				</div>
				<!-- vcam count -->
				<div v-if="isVcam" class="form-group mb-3 mr-4 mt-4">
					<select
						name="size"
						class="form-control"
						v-model="template.vcam_count"
						required>
						<option value="" disabled selected>Select V-Cam Display Limit</option>
						<option
							v-for="vCamCount in vCamCounts"
							:key="vCamCount.value"
							:value="vCamCount.value">
							{{ vCamCount.name }}
						</option>
					</select>
				</div>
				<!-- File Path -->
				<div v-if="!isVcam" class="form-group mb-3 mr-4 mt-4">
					<!-- Upload -->
				<label
					class="btn btn-primary mb-0">
					<span class="text-black">{{ $t('Upload Lottie') }}</span>
					<input
						type="file"
						accept=".json"
						class="hidden"
						@change="onFileSelected"
					/>
				</label>
				</div>
				<!-- File SVG Path -->
				<div v-if="isVcam" class="form-group mb-3 mr-4 mt-4">
					<!-- Upload -->
				<label
					class="btn btn-primary mb-0">
					<span class="text-black">{{ $t('Upload SVG') }}</span>
					<input
						type="file"
						accept=".svg"
						class="hidden"
						@change="onSVGSelected"
					/>
				</label>
				</div>
				<!-- File Path -->
				<div class="form-group mb-3 mr-4 mt-4">
					<!-- Upload -->
				<label
					class="btn btn-primary mb-0">
					<div v-if="isUploadingImage" class="spinner-border spinner-border-sm" role="status">
						<span class="sr-only">Loading...</span>
					</div>
					<span v-if="!isUploadingImage" class="text-black">{{ $t('Upload Image preview') }}</span>
					<input
						type="file"
						accept=".png,.gif,.jpeg,.jpg"
						class="hidden"
						@change="onImagePreviewSelected"
					/>
				</label>
				</div>
				<!-- Upload Assets -->
				<div class="form-group mb-3 mr-4 mt-4" v-if="template.file_path" @click="isUploadAssetVisible = true">
					<!-- Upload -->
					<label
						class="btn btn-primary mb-0">
						<div v-if="isUploadingAssets" class="spinner-border spinner-border-sm" role="status">
							<span class="sr-only">Loading...</span>
						</div>
						<span v-if="!isUploadingAssets" class="text-black">{{ $t('Upload Assets') }}</span>
					</label>
				</div>
				<!-- Assign to specific users -->
				<div v-if="checkEdit !== 'new' && (user && template && template.user_id === user.id)" class="form-group mb-3 mr-4 mt-4" @click="openModalAssignUser">
					<!-- Upload -->
					<label
						class="btn btn-primary mb-0">
						<span class="text-black">{{ $t('Assign to User') }}</span>
					</label>
				</div>
				<!-- Add New -->
				<div class="text-right ml-auto mr-4" v-if="checkEdit === 'new'">
					<button
						type="submit"
						:disabled="!template.name"
						:class="{'is-loading': isSaving}"
						class="btn btn-primary mt-4 mb-2"
						@click="createTemplate()">
						{{ $t('Create Template') }}
					</button>
				</div>
				<!-- Update -->
				<div class="text-right ml-auto mr-4" v-if="checkEdit !== 'new'">
					<button
						type="submit"
						:disabled="!template.name"
						:class="{'is-loading': isSaving}"
						class="btn btn-primary mt-4 mb-2"
						@click="createTemplate()">
						{{ $t('Update Template') }}
					</button>
				</div>
			</div>
		</div>
		<hr class="divider-template" v-show="!tempFilePath">
		<content class="card-multipane template-editor">
			<Split class="main-split" :gutterSize=16 direction='vertical'>
				<SplitArea  :size="50" :minSize="0" v-show="!tempFilePath">
					<Split :gutterSize=16>
						<SplitArea :size="33" :minSize="30">
							<label class="title-code-mirror mt-3 ml-3">HTML</label>
							<div class="box-html box-editor">
								<codemirror v-model="template.content" :options="cmOptionsHTML"></codemirror>
							</div>
						</SplitArea>
						<SplitArea :size="33" :minSize="30">
							<label class="title-code-mirror mt-3 ml-3">CSS</label>
							<div class="box-css box-editor">
								<codemirror v-model="template.style" :options="cmOptionsCss"></codemirror>
							</div>
						</SplitArea>
						<SplitArea :size="34" :minSize="30">
							<label class="title-code-mirror mt-3 ml-3" height="10px">JS</label>
							<div class="box-js box-editor">
								<codemirror v-model="template.script" :options="cmOptionsCss"></codemirror>
							</div>
						</SplitArea>
					</Split>
				</SplitArea>
				<SplitArea>
					<TemplatePreview ref="templatePreview" :template="activeTemplate" :lottieTemplate="activeLottie" />
				</SplitArea>
			</Split>
		</content>
		<!-- Macros List -->
		<modal
			class="macro-list-modal"
			size="small"
			@close="isUploadAssetVisible = false"
			v-if="isUploadAssetVisible">
			<template slot="header">
				<div>{{ $t('Upload Assets') }}</div>
			</template>
			<template slot="body">
				<div >{{ $t(`Make sure the .zip file you upload is not "Protected" and has no "Folder" in it`) }}</div>
			</template>
			<template slot="footer">
				<div class="w-100 flex-center">
					<label
						class="btn btn-primary mb-0">
						<span class="text-black">{{ $t('Ok') }}</span>
						<input
							type="file"
							accept=".zip"
							class="hidden"
							@change="onFileAssetSelected"
						/>
					</label>
					<button
						class="btn btn-default"
						@click="isUploadAssetVisible = false">
						{{ $t('Cancel') }}
					</button>
				</div>
			</template>
		</modal>
		<modal-assign-user :titleAssignModal="'template'" :data="template" :isShowAssign="isShowAssign" @close="isShowAssign = false"/>
	</span>
</template>

<script>
import $ from 'jquery';
import Loading from 'vue-loading-overlay';
import { mapGetters } from 'vuex';
import 'vue-loading-overlay/dist/vue-loading.css';
import { codemirror } from 'vue-codemirror';
import localforage from 'localforage';
import Modal from '@/components/Modal.vue';
import templatesApi from '@/api/templates';
import TemplatePreview from '@/components/TemplatePreview.vue';
import ModalAssignUser from '@/components/ModalAssignUser.vue';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/monokai.css';
import 'codemirror/mode/htmlmixed/htmlmixed';
import 'codemirror/mode/css/css';
import categoriesApi from '@/api/categories';
import fileApi from '@/api/file';

import {
	getAxiosErrorMessage,
	// delay,
	getVideoBlob,
} from '@/lib/helper';

const defaultTemplate = {
	name: '',
	type: '',
	descriptions: '',
	content: '',
	category: '',
	file_path: '',
	img_path: '',
};
export default {
	name: 'TemplateEditor',
	props: {
		rundown: {
			type: Object,
		},
	},
	components: {
		codemirror,
		TemplatePreview,
		Loading,
		Modal,
		ModalAssignUser,
	},
	data() {
		return {
			template: defaultTemplate,
			code: 'const a = 11',
			cmOptionsHTML: {
			// codemirror options
				tabSize: 4,
				mode: 'htmlmixed',
				theme: 'monokai',
				lineNumbers: true,
				line: true,
				height: 'auto',
				lineWrapping: true,
			},
			cmOptionsCss: {
			// codemirror options
				tabSize: 4,
				mode: 'text/css',
				theme: 'monokai',
				lineNumbers: true,
				line: true,
				lineWrapping: true,
			},
			htmlHeight: 300,
			types: [{
				name: 'Lower Third',
				value: 'lower_third',
			},
			{
				name: 'Ticker',
				value: 'ticker',
			},
			{
				name: 'Bumper',
				value: 'bumper',
			},
			{
				name: 'Timer',
				value: 'timer',
			},
			{
				name: 'Virtual Cam',
				value: 'virtual_cam',
			}],
			isLoadingTemplate: false,
			isUploading: false,
			isUploadingImage: false,

			paramsUpdate: '',
			categories: [],
			uploadProgress: 0,
			images: [
				'https://grafias-medias.s3.eu-central-1.amazonaws.com/img/TemplateThumbnailDefault_01.jpg',
				'https://grafias-medias.s3.eu-central-1.amazonaws.com/img/TemplateThumbnailDefault_02.jpg',
				'https://grafias-medias.s3.eu-central-1.amazonaws.com/img/TemplateThumbnailDefault_03.jpg',
				'https://grafias-medias.s3.eu-central-1.amazonaws.com/img/TemplateThumbnailDefault_04.jpg',
			],
			previewTemplate: {},
			isUploadingAssets: false,
			colorOverlay: '#000000',
			colorLoading: '#FFFFFF',
			isUploadAssetVisible: false,
			vCamCounts: [
				{
					name: '1',
					value: 1,
				},
				{
					name: '2',
					value: 2,
				},
				{
					name: '3',
					value: 3,
				},
				{
					name: '4',
					value: 4,
				},
				{
					name: '5',
					value: 5,
				},
				{
					name: '6',
					value: 6,
				},
				{
					name: '7',
					value: 7,
				},
				{
					name: '8',
					value: 8,
				},
				{
					name: '9',
					value: 9,
				},
				{
					name: '10',
					value: 10,
				},
				{
					name: '11',
					value: 11,
				},
				{
					name: '12',
					value: 12,
				},
			],
			thumbnail: null,
			cancelRequest: null,
			cancelRequestArray: [],
			cancelActive: false,
			isShowAssign: false,
			isSaving: false,
			tempFilePath: false,
		};
	},
	mounted() {
		this.showPreviewCount = 0;
		const templateId = this.$route.params.template;
		if (templateId !== 'new') {
			this.getTemplateById(templateId);
		} else {
			this.template.type = 'lower_third';
			this.template.name = '';
			this.template.description = '';
			this.template.content = '';
			this.template.style = '';
			this.template.duration = '';
			this.template.script = '';
			this.template.category = 3;
			this.template.vcam_count = '';
		}
		window.addEventListener('resize', this.onResizeWidth);
		this.onResizeWidth();
		window.addEventListener('resize', this.onResizeHeight);
		this.onResizeHeight();
	},
	methods: {
		onFileSelected(e) {
			const files = e.target.files;
			if (files.length > 0) {
				if (files[0].type === 'application/json') {
					const file = files[0];
					if (!file) {
						this.$notify({
							group: 'app',
							type: 'warn',
							title: 'Upload Media',
							text: 'Sorry, currently we cant upload the file',
						});
						return;
					}

					this.isUploading = true;
					const params = new FormData();
					params.append('file', file);
					// params.append('type', 'lottie');
					const callback = (response) => {
						// const mediaUrl = response.data;
						this.template.file_path = response.data;
						// this.mediaUrl = mediaUrl;
						// this.addMedia();
						this.isUploading = false;
						this.uploadProgress = 0;
					};
					const errorCallback = (e) => {
						const message = getAxiosErrorMessage(e);
						this.$notify({
							group: 'app',
							type: 'error',
							title: 'Upload Media',
							text: message,
						});
						this.isUploading = false;
					};
					const progressCallback = (progress) => {
						this.uploadProgress = progress;
					};
					fileApi.upload(params, callback, errorCallback, progressCallback);
				} else {
					this.$notify({
						group: 'app',
						type: 'warning',
						title: 'Upload Media',
						text: 'Unsupported file',
					});
					// eslint-disable-next-line
					return;
				}
			}
		},
		onSVGSelected(e) {
			const files = e.target.files;
			if (files.length > 0) {
				if (files[0].type === 'image/svg+xml') {
					const file = files[0];
					if (!file) {
						this.$notify({
							group: 'app',
							type: 'warn',
							title: 'Upload Media',
							text: 'Sorry, currently we cant upload the file',
						});
						return;
					}

					this.isUploading = true;
					const params = new FormData();
					params.append('file', file);
					// params.append('type', 'lottie');
					const callback = (response) => {
						this.template.svg_path = response.data;
						this.isUploading = false;
						this.uploadProgress = 0;
					};
					const errorCallback = (e) => {
						const message = getAxiosErrorMessage(e);
						this.$notify({
							group: 'app',
							type: 'error',
							title: 'Upload Media',
							text: message,
						});
						this.isUploading = false;
					};
					const progressCallback = (progress) => {
						this.uploadProgress = progress;
					};
					fileApi.upload(params, callback, errorCallback, progressCallback);
				} else {
					this.$notify({
						group: 'app',
						type: 'warning',
						title: 'Upload Media',
						text: 'Unsupported file',
					});
					// eslint-disable-next-line
					return;
				}
			}
		},
		onImagePreviewSelected(e) {
			const files = e.target.files;
			if (files.length > 0) {
				if (files[0].type === 'image/jpeg' || files[0].type === 'image/gif' || files[0].type === 'image/png' || files[0].type === 'image/jpg') {
					const file = files[0];
					if (!file) {
						this.$notify({
							group: 'app',
							type: 'warn',
							title: 'Upload Media',
							text: 'Sorry, currently we cant upload the file',
						});
						return;
					}

					this.isUploadingImage = true;
					const params = new FormData();
					params.append('file', file);
					// params.append('type', 'lottie');
					const callback = (response) => {
						// const mediaUrl = response.data;
						this.thumbnail = response.data;
						this.template.img_path = response.data;
						// this.mediaUrl = mediaUrl;
						// this.addMedia();
						this.isUploadingImage = false;
						this.uploadProgress = 0;
					};
					const errorCallback = (e) => {
						const message = getAxiosErrorMessage(e);
						this.$notify({
							group: 'app',
							type: 'error',
							title: 'Upload Media',
							text: message,
						});
						this.isUploadingImage = false;
					};
					const progressCallback = (progress) => {
						this.uploadProgress = progress;
					};
					fileApi.upload(params, callback, errorCallback, progressCallback);
				} else {
					this.$notify({
						group: 'app',
						type: 'warning',
						title: 'Upload Media',
						text: 'Unsupported file',
					});
					// eslint-disable-next-line
					return;
				}
			}
		},
		onFileAssetSelected(e) {
			const files = e.target.files;
			if (files.length > 0) {
				if (files[0].type === 'application/x-zip-compressed' || files[0].type === 'application/zip') {
					const file = files[0];
					if (!file) {
						this.$notify({
							group: 'app',
							type: 'warn',
							title: 'Upload Media',
							text: 'Sorry, currently we cant upload the file',
						});
						return;
					}

					this.isUploadingAssets = true;
					const params = new FormData();
					params.append('file', file);
					// params.append('type', 'lottie');
					const callback = (response) => {
						// const mediaUrl = response.data;
						this.template.assets_url = response.data;
						// this.mediaUrl = mediaUrl;
						// this.addMedia();
						this.isUploadingAssets = false;
						this.uploadProgress = 0;
						this.isUploadAssetVisible = false;
					};
					const errorCallback = (e) => {
						const message = getAxiosErrorMessage(e);
						this.$notify({
							group: 'app',
							type: 'error',
							title: 'Upload Media',
							text: message,
						});
						this.isUploadingAssets = false;
					};
					const progressCallback = (progress) => {
						this.uploadProgress = progress;
					};
					fileApi.upload(params, callback, errorCallback, progressCallback);
				} else {
					this.$notify({
						group: 'app',
						type: 'warning',
						title: 'Upload Media',
						text: 'Unsupported file',
					});
					// eslint-disable-next-line
					return;
				}
			}
		},
		createTemplate() {
			this.isSaving = true;
			const callback = (response) => {
				const item = response.data;
				this.tempFilePath = item.file_path;
				const message = response.message;
				if (this.checkEdit === 'new') {
					this.template.name = '';
				}
				// recahce
				const itemKey = `thumbnail_template_${this.$route.params.template}`;
				// eslint-disable-next-line
				localforage.getItem(itemKey, (err, value) => {
					const itemMediaThumbnail = this.template.img_path;
					const itemMediaName = response && response.data.name ? response.data.name : 'template';
					if (itemMediaThumbnail) {
						try {
							getVideoBlob(itemMediaThumbnail).then((blob) => {
								// Set key and blob
								localforage.setItem(itemKey, blob, (err, value) => {
									if (!err && value) {
										// handle success cache here
									}
									if (err) {
										this.$notify({
											duration: 6000,
											closeOnClick: true,
											group: 'app',
											type: 'error',
											title: 'Error loading media',
											text: 'Something went wrong please contact admin!',
										});
									}
								});
							}).catch(() => {
								// error handling logic
								const message = `Template: ${itemMediaName}. Sorry, some media file can't be loaded or media not found, please check`;
								this.$notify({
									duration: 6000,
									closeOnClick: true,
									group: 'app',
									type: 'error',
									title: 'Error loading Template',
									text: message,
								});
							});
						} catch (e) {
						// catch some error here
						}
					}
				});
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Template',
					text: message,
				});
				this.isSaving = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Template',
					text: message,
				});
				this.isSaving = false;
			};
			if (this.checkEdit !== 'new') {
				this.beforeParamsUpdate();
				templatesApi.update(this.template.id, this.paramsUpdate, callback, errorCallback);
				this.template.file_path = '';
			} else {
				// window.close();
				templatesApi.create(this.templateParams, callback, errorCallback);
			}
		},
		getTemplateById(templateId) {
			this.isLoadingTemplate = true;
			const callback = (response) => {
				this.template.id = response.data.id;
				this.template.type = response.data.type;
				this.template.name = response.data.name;
				this.template.description = response.data.description;
				this.template.content = JSON.parse(response.data.content).content;
				this.template.style = JSON.parse(response.data.content).style;
				this.template.script = JSON.parse(response.data.content).script;
				this.template.vcam_count = JSON.parse(response.data.content).vcam_count;
				this.template.file_path = response.data.file_path;
				this.tempFilePath = this.template.file_path;
				this.template.img_path = response.data.img_path;
				this.template.svg_path = response.data.svg_path;
				this.template.assets_url = response.data.assets_url;
				this.template.category = response.data.category_id;
				this.template.user_id = response.data.user_id;
				this.isLoadingTemplate = false;
			};
			const templateErrorCallback = (e) => {
				// eslint-disable-next-line
				const response = e.response ? e.response.data : false;
				const message = response ? response.message : '';
				this.$notify({
					group: 'Notification',
					type: 'error',
					title: this.$t('Error'),
					text: message,
				});
				this.isLoadingTemplate = false;
			};
			templatesApi.get(templateId, callback, templateErrorCallback);
		},
		beforeParamsUpdate() {
			const templateId = this.template && this.template.id ? this.template.id : '';
			this.deleteLocalForage(templateId);
			const content = {
				content: this.template.content,
				style: this.template.style,
				script: this.template.script,
				vcam_count: this.template.vcam_count,
			};
			this.previewTemplate = content;
			const contentString = JSON.stringify(content);
			const params = {
				name: this.template.name,
				type: this.template.type,
				file_path: this.template.file_path,
				img_path: this.template.img_path,
				assets_url: this.template.assets_url,
				svg_path: this.template.svg_path,
				content: contentString,
				status: 1,
				description: this.template.description,
				category_id: this.template.category,
			};
			if (this.template.img_path) {
				params.img_path = this.template.img_path;
			} else {
				params.img_path = this.randomImage(this.images);
			}
			if (this.template.file_path) {
				params.file_path = this.template.file_path;
			}
			if (this.template.assets_url) {
				params.assets_url = this.template.assets_url;
			}
			if (this.template.svg_path) {
				params.svg_path = this.template.svg_path;
			}
			this.paramsUpdate = params;
		},
		onResizeWidth() {
			if (window.innerWidth <= 2200 && window.innerWidth > 1920) {
				$(document).find('.main-split').css('height', '1000px');
			} else if (window.innerWidth > 2000) {
				$(document).find('.main-split').css('height', '1795px');
			} else if (window.innerWidth <= 1920 && window.innerWidth > 1000) {
				$(document).find('.main-split').css('height', '900px');
			}
		},
		onResizeHeight() {
			if (window.innerHeight <= 1200 && window.innerHeight > 1000) {
				$(document).find('.main-split').css('height', '1595px');
			} else if (window.innerHeight > 1200) {
				$(document).find('.main-split').css('height', '1795px');
			} else if (window.innerHeight > 1700) {
				$(document).find('.main-split').css('height', '1995px');
			}
		},
		fetchCategories() {
			const params = {
				page: 1,
				limit: 1000,
				order_by: 'name',
				sort_by: 'asc',
				type: 'template',
			};
			const callback = (response) => {
				const categories = response.data.data;
				this.categories = categories;
			};
			const errorCallback = () => {};
			categoriesApi.getList(params, callback, errorCallback);
		},
		randomImage(items) {
			return items[Math.floor(Math.random() * 4)];
		},
		textKeydown(e) {
			if (/[^A-Z0-9-_ ]/gi.test(e.key)) {
				e.preventDefault();
			}
		},
		openModalAssignUser() {
			this.isShowAssign = true;
		},
		deleteLocalForage(templateId) {
			const itemKey = `lottie_lt_${templateId}`;
			localforage.getItem(itemKey).then(() => {
				localforage.removeItem(itemKey);
			});
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		templateParams() {
			const content = {
				content: this.template.content,
				style: this.template.style,
				script: this.template.script,
				vcam_count: this.template.vcam_count,
			};
			const contentString = JSON.stringify(content);
			const params = {
				name: this.template.name,
				type: this.template.type,
				content: contentString,
				category_id: this.template.category,
				status: 1,
				description: this.template.description,

			};
			if (this.template.img_path) {
				params.img_path = this.template.img_path;
			} else {
				params.img_path = this.randomImage(this.images);
			}
			if (this.template.file_path) {
				params.file_path = this.template.file_path;
			}
			if (this.template.assets_url) {
				params.assets_url = this.template.assets_url;
			}
			if (this.template.svg_path) {
				params.svg_path = this.template.svg_path;
			}
			return params;
		},
		codemirror() {
			return this.$refs.myCm.codemirror;
		},
		activeTemplate() {
			return this.previewTemplate;
		},
		activeLottie() {
			const filePath = this.template && this.template.file_path ? this.template.file_path : '';
			return filePath;
		},
		checkEdit() {
			return this.$route.params.template;
		},
		isVcam() {
			return this.template.type === 'virtual_cam';
		},
	},
	created() {
		this.fetchCategories();
	},
	watch: {

	},
};
</script>

<style>
</style>
